/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_SubtitleInputs */

const en_about_subtitle = /** @type {(inputs: About_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Built in Germany, for European job seekers.`)
};

const de_about_subtitle = /** @type {(inputs: About_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entwickelt in Deutschland, fuer europaeische Jobsuchende.`)
};

const fr_about_subtitle = /** @type {(inputs: About_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Développé en Allemagne, pour les chercheurs d'emploi européens.`)
};

const es_about_subtitle = /** @type {(inputs: About_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hecho en Alemania, para buscadores de empleo europeos.`)
};

const it_about_subtitle = /** @type {(inputs: About_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Costruito in Germania, per chi cerca lavoro in Europa.`)
};

const nl_about_subtitle = /** @type {(inputs: About_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebouwd in Duitsland, voor Europese werkzoekenden.`)
};

const pl_about_subtitle = /** @type {(inputs: About_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stworzone w Niemczech, dla europejskich osob szukajacych pracy.`)
};

const fi_about_subtitle = /** @type {(inputs: About_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rakennettu Saksassa, eurooppalaisille työnhakijoille.`)
};

const da_about_subtitle = /** @type {(inputs: About_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bygget i Tyskland, for europaeiske jobsogere.`)
};

const sv_about_subtitle = /** @type {(inputs: About_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Byggt i Tyskland, for europeiska jobbsokare.`)
};

/**
* | output |
* | --- |
* | "Built in Germany, for European job seekers." |
*
* @param {About_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const about_subtitle = /** @type {((inputs?: About_SubtitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_SubtitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_about_subtitle(inputs)
	if (locale === "fr") return fr_about_subtitle(inputs)
	if (locale === "es") return es_about_subtitle(inputs)
	if (locale === "it") return it_about_subtitle(inputs)
	if (locale === "nl") return nl_about_subtitle(inputs)
	if (locale === "pl") return pl_about_subtitle(inputs)
	if (locale === "fi") return fi_about_subtitle(inputs)
	if (locale === "da") return da_about_subtitle(inputs)
	if (locale === "sv") return sv_about_subtitle(inputs)
	return en_about_subtitle(inputs)
});